

















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { httpsImg } from '@/utils/tool'

@Component({
  name: 'List',
  components: {
  }
})

export default class Tabs extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  loading!: boolean

  /**
   * @param {array} list 列表数据
   * @description: 默认空数组
   */
  @Prop({
    type: Array,
    default: () => ([])
  }) list!: Array<any>

  private httpsImg = httpsImg

  // 点击景区
  @Emit('click')
  changeItem (item: any) {
    return item
  }
}
